import { AxiosInstance } from 'axios';
import { splunk_log_type, splunk_message } from '../common/splunk_constant';

export default class FavoriteService {
  visionBffClient: AxiosInstance;
  splunkLogger?: any;

  constructor(visionBffClient: AxiosInstance, splunkLogger?:any) {
    this.visionBffClient = visionBffClient;
    this.splunkLogger = splunkLogger;
  }

  async addFavorite(skus: string[]) {
    const graphqlQuery = {
      query: `
      mutation($listOfSkus: [String!]!) {
        addToFavorites(listOfSkus: $listOfSkus) { ...FavoritesFields }
      }

       fragment FavoritesFields on Favorite {
        id
        version
        name
        key
        customer
        slug
        lineItems
        textLineItems
        deleteDaysAfterLastModification
        createdAt
        lastModifiedAt
       }
        `,
      variables: { listOfSkus: skus },
    };
    try {
      const response = await this.visionBffClient({
        method: 'POST',
        url: '/api/v1/user',
        data: graphqlQuery,
      });
      this.splunkLogger?.({
        logType: splunk_log_type.INFO,
        data: splunk_message.SUCCESS.ADD_FAVORITE_SUCCESS
      })
      return response?.data?.data?.addToFavorites;
    } catch (error) {
      this.splunkLogger?.({
        logType: splunk_log_type.ERROR,
        data: { ...splunk_message.ERROR.ADD_FAVORITE_ERROR, error}
      })
      throw error;
    }
  }

  async removeFavorite(skus: string[]) {
    const graphqlQuery = {
      query: `
        fragment FavoritesFields on Favorite {
          id
          version
          name
          key
          customer
          slug
          lineItems
          textLineItems
          deleteDaysAfterLastModification
          createdAt
          lastModifiedAt
      }

      mutation($listOfSkus: [String!]!) {
        removeFromFavorites(listOfSkus: $listOfSkus) { ...FavoritesFields }
      }
        `,
      variables: { listOfSkus: skus },
    };
    try {
      const response = await this.visionBffClient({
        method: 'POST',
        url: '/api/v1/user',
        data: graphqlQuery,
      });
      this.splunkLogger?.({
        logType: splunk_log_type.INFO,
        data: splunk_message.SUCCESS.REMOVE_FAVORITE_SUCCESS
      })
      return response?.data?.data.removeFromFavorites;
    } catch (error) {
      this.splunkLogger?.({
        logType: splunk_log_type.ERROR,
        data: { ...splunk_message.ERROR.REMOVE_FAVORITE_ERROR, error}
      })
      throw error;
    }
  }

  async getFavorites() {
    const graphqlQuery = {
      query: `
            fragment FavoritesFields on Favorite {
              id
              version
              name
              key
              customer
              slug
              lineItems
              textLineItems
              deleteDaysAfterLastModification
              createdAt
              lastModifiedAt
          }

          query GetFavorites {
            favorites { ...FavoritesFields }
          }
        `,
    };
    try {
      const response = await this.visionBffClient({
        method: 'POST',
        url: '/api/v1/user',
        data: graphqlQuery,
      });
      this.splunkLogger?.({
        logType: splunk_log_type.INFO,
        data: splunk_message.SUCCESS.GET_FAVORITE_SUCCESS
      })
      return response?.data?.data.favorites;
    } catch (error) {
      this.splunkLogger?.({
        logType: splunk_log_type.ERROR,
        data: { ...splunk_message.ERROR.GET_FAVORITE_ERROR, error}
      })
      throw error;
    }
  }
}
